import * as React from "react";
import ReactTooltip from "react-tooltip";
import Button from "@material-ui/core/Button";
import "./BOSideItemStyle.css";

interface Props {
  icon: string;
  name: string;
  title: string;
  active?: boolean;
  onClick: (name: string) => void;
}

export default class BOSideItem extends React.Component<Props, {}> {
  render() {
    return (
      <li data-tip={this.props.title}>
        <Button
          style={{
            width: "60px",
            minWidth: "0",
            height: "60px",
            minHeight: "0",
            fontSize: "22px"
          }}
          className={`BOSideItem ${this.props.active ? "active" : null}`}
          onClick={() => this.props.onClick(this.props.name)}
        >
          <i className={`fa ${this.props.icon}`} />
        </Button>
        <ReactTooltip effect="solid" />
      </li>
    );
  }
}
